import React, { useEffect, useState, useRef } from "react";
import "./galerija.css";

const Galerija = () => {
  const [title, setTitle] = useState("");
  const [excerpt, setExcerpt] = useState("");
  const [images, setImages] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  const touchStartX = useRef(null);

  useEffect(() => {

    fetch("https://ghost-crew.eu/wp-json/wp/v2/posts/44")
      .then((res) => res.json())
      .then((post) => {
        setTitle(post.title.rendered);
        setExcerpt(post.excerpt.rendered);
      });

    fetch("https://ghost-crew.eu/wp-json/wp/v2/media?parent=44&per_page=100")
      .then((res) => res.json())
      .then((data) => {
        const imgs = data.map((item) => ({
          id: item.id,
          src: item.source_url,
          title: item.title.rendered,
        }));
        setImages(imgs);
      })
      .catch((err) => console.log(err));

  }, []);

  const nextImage = () => {
    setActiveIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setActiveIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  // TOUCH SWIPE
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (diff > 50) nextImage();
    if (diff < -50) prevImage();
    touchStartX.current = null;
  };

  return (
    <div className="gal-wrapper">

      <h1 className="gal-title">{title}</h1>

      <div className="gal-intro">
  <p
    className="gal-excerpt"
    dangerouslySetInnerHTML={{ __html: excerpt }}
  />
  
   <a href="https://www.instagram.com/res_car_photography/"
    target="_blank"
    rel="noopener noreferrer"
    className="ig-btn "
  >
    <i className="fa-brands fa-instagram" /> Pogledaj još slika!
  </a>
</div>

      <div className="gal-grid">
        {images.length > 0 ? (
          images.map((img, index) => (
            <img
              key={img.id}
              src={img.src}
              alt={img.title}
              onClick={() => setActiveIndex(index)}
            />
          ))
        ) : (
          <p>Nema slika.</p>
        )}
      </div>

      {activeIndex !== null && (
        <div
          className="lightbox"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >

          <button
            className="close-btn"
            onClick={() => setActiveIndex(null)}
          >
            ✕
          </button>

          <button
            className="nav-btn left"
            onClick={prevImage}
          >
            ❮
          </button>

          <img
            src={images[activeIndex].src}
            alt=""
            className="lightbox-img"
          />

          <button
            className="nav-btn right"
            onClick={nextImage}
          >
            ❯
          </button>

        </div>
      )}

    </div>
  );
};

export default Galerija;